import React from 'react'
import injectStyles from 'react-jss'

import { styles } from './styles'
import { numberToThousand } from '../../utils'
import { formatNumberToCommas } from '../utils'

const Stats = ({ classes, distributedByThisDate, data, average, median }) => {
  const items = [
    {
      circle: true,
      value: `${Math.trunc((distributedByThisDate / data.totalMailed) * 100)}%`,
      valueDescription: 'Delivered',
      subTitle: `${numberToThousand(
        distributedByThisDate,
      )} of ${numberToThousand(data.totalMailed)}`,
    },
    {
      circle: false,
      value: formatNumberToCommas(Math.trunc(median)),
      valueDescription: '',
      subTitle: 'Median of distribution',
    },
    {
      circle: false,
      value: formatNumberToCommas(Math.trunc(average)),
      valueDescription: '',
      subTitle: 'Postage Velocity*',
    },
  ]

  return (
    <div className={classes.wrapper}>
      {items.map(item => (
        <div className={classes.item}>
          <div className={classes.general}>
            {item.circle && <div className={classes.circle} />}
            <div className={classes.value}>{item.value}</div>
            <div className={classes.valueDescription}>
              {item.valueDescription}
            </div>
          </div>
          <div className={classes.subTitle}>{item.subTitle}</div>
        </div>
      ))}
    </div>
  )
}

export default injectStyles(styles)(Stats)
